define(
    'CommerceCategorySearchResults.Plugin',
    [
        'CommerceCategorySearchResults.CategorySuggestion.View',
        'Categories',
        'underscore'
    ],
    function(
        CategorySuggestionView,
        Categories,
        _
    ) {
        'use strict';

        var CATEGORY_RESULT_PREFIX = 'commerce-category-';
        var CATEGORY_RESULT_TYPE = 'commercecategory';
        var MAX_CATEGORY_RESULTS = 3;
        var cachedCategoriesSource;
        var cachedFlattenedCategories;

        function normalizeValue(value) {
            return String(value || '')
                .toLowerCase()
                .replace(/&/g, ' and ')
                .replace(/[^a-z0-9]+/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
        }

        function getCategoryFullUrl(category) {
            return category && (category.fullurl || category.url || category.href || '');
        }

        function getCategoryChildren(category) {
            return category && category.categories ? category.categories : [];
        }

        function buildBreadcrumb(parentNames, categoryName) {
            var names = parentNames.slice(0);

            if (categoryName) {
                names.push(categoryName);
            }

            return names.join(' / ');
        }

        function flattenCategories(categories, parentNames, flattened) {
            flattened = flattened || [];
            parentNames = parentNames || [];

            _.each(categories || [], function(category) {
                var name = category && category.name;
                var fullurl = getCategoryFullUrl(category);

                if (category && category.displayinsite !== false && name && fullurl) {
                    flattened.push({
                        id: String(category.internalid || fullurl),
                        name: name,
                        fullurl: fullurl,
                        normalizedName: normalizeValue(name),
                        breadcrumb: buildBreadcrumb(parentNames, name),
                        normalizedBreadcrumb: normalizeValue(buildBreadcrumb(parentNames, name))
                    });
                }

                flattenCategories(
                    getCategoryChildren(category),
                    parentNames.concat(name || []),
                    flattened
                );
            });

            return flattened;
        }

        function scoreCategory(category, normalizedQuery) {
            var name = category.normalizedName;
            var breadcrumb = category.normalizedBreadcrumb;

            if (!normalizedQuery || !name) {
                return -1;
            }

            if (name === normalizedQuery) {
                return 500;
            }

            if (name.indexOf(normalizedQuery + ' ') === 0 || name.indexOf(normalizedQuery) === 0) {
                return 400;
            }

            if (name.indexOf(' ' + normalizedQuery) !== -1) {
                return 300;
            }

            if (name.indexOf(normalizedQuery) !== -1) {
                return 200;
            }

            if (breadcrumb.indexOf(normalizedQuery) !== -1) {
                return 100;
            }

            return -1;
        }

        function getFlattenedCategories() {
            var categories = SC.CATEGORIES || [];

            if (cachedCategoriesSource !== categories) {
                cachedCategoriesSource = categories;
                cachedFlattenedCategories = flattenCategories(categories);
            }

            return cachedFlattenedCategories || [];
        }

        function findMatchingCategories(query) {
            var normalizedQuery = normalizeValue(query);
            var flattenedCategories = getFlattenedCategories();

            return _.chain(flattenedCategories)
                .map(function(category) {
                    return {
                        category: category,
                        score: scoreCategory(category, normalizedQuery)
                    };
                })
                .filter(function(result) {
                    return result.score >= 0;
                })
                .sortBy(function(result) {
                    return -1 * result.score;
                })
                .pluck('category')
                .uniq(false, function(category) {
                    return category.id;
                })
                .first(MAX_CATEGORY_RESULTS)
                .value();
        }

        function buildCategoryModel(category) {
            var prefixedId = CATEGORY_RESULT_PREFIX + category.id;

            return {
                internalid: prefixedId,
                itemid: category.name,
                _id: prefixedId,
                _name: category.name,
                _url: category.fullurl,
                _isCategorySuggestion: true,
                _resultType: CATEGORY_RESULT_TYPE,
                _categoryBreadcrumb: category.breadcrumb,
                _categoryId: category.id
            };
        }

        function mergeCategoryResults(collection, options) {
            var categoryModels;
            var existingItemModels;
            var combinedModels;
            var limit;

            if (!options || !options.query) {
                return collection;
            }

            categoryModels = _.map(findMatchingCategories(options.query), buildCategoryModel);

            if (!categoryModels.length) {
                return collection;
            }

            existingItemModels = _.filter(collection.models, function(model) {
                return !(model && model.get && model.get('_isCategorySuggestion'));
            });

            limit = collection.length;

            if (!limit && options.limit) {
                limit = options.limit;
            }

            combinedModels = categoryModels.concat(existingItemModels);

            if (limit > 0) {
                combinedModels = combinedModels.slice(0, limit);
            }

            collection.reset(combinedModels, { silent: true });

            return collection;
        }

        function overrideSuggestionTemplate(itemsSearcherComponent) {
            if (itemsSearcherComponent._commerceCategorySuggestionTemplateOverridden) {
                return;
            }

            itemsSearcherComponent._commerceCategorySuggestionTemplateOverridden = true;
            itemsSearcherComponent._commerceCategoryOriginalSuggestionTemplate =
                itemsSearcherComponent.getSuggestionItemTemplate;

            itemsSearcherComponent.getSuggestionItemTemplate = function getSuggestionItemTemplate(itemId) {
                var model = this.collection.get(itemId);
                var categorySuggestionView;

                if (!(model && model.get && model.get('_isCategorySuggestion'))) {
                    return this._commerceCategoryOriginalSuggestionTemplate.apply(this, arguments);
                }

                categorySuggestionView = new CategorySuggestionView({
                    model: model,
                    query: this.options.query
                });
                categorySuggestionView.render();

                return categorySuggestionView.$el;
            };
        }

        return {
            install: function install(itemsSearcherComponent) {
                if (
                    !itemsSearcherComponent ||
                    itemsSearcherComponent._commerceCategorySearchResultsInstalled
                ) {
                    return;
                }

                itemsSearcherComponent._commerceCategorySearchResultsInstalled = true;

                itemsSearcherComponent.postItemsSuggestionObtained.install({
                    name: 'CommerceCategorySearchResults',
                    priority: 10,
                    execute: mergeCategoryResults
                });

                overrideSuggestionTemplate(itemsSearcherComponent);
            }
        };
    }
);
